// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSummary-SummaryContainer_cls1__6dCx3","cls2":"VeloSummary-SummaryContainer_cls2__kmh4w VeloSummary-SummaryContainer_cls1__6dCx3"};